import {type ClientConfig} from "@root/server/common/fastify/clientConfig.ts";


export function getClientConfig(): ClientConfig {

    const configJson = document.querySelector('meta[name="CLIENT_CONFIG"]')?.getAttribute('content');

    if(!configJson) {
        throw new Error('Client config is not available.');
    }

    const _config = JSON.parse(configJson);

    return _config;
}
